import * as types from 'actions';

export const initialState={
  noServiceResponse: false,
  findByPhone: false,
  isDonorVerified: false,
  redirectUrl: ''
}

export default function(state = [], action) {
  let response = '';
  let allDonors = '';
  let addVolunteerDonor = '';
  let deleteVolunteerDonor ='';
  let addActualDonor = '';
  let importDonors = '';
  let sendOTPDonor = undefined;
  switch(action.type) {
    case types.DONOR_SUBMIT_SUCCESS:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        response };  
    case types.DONOR_SUBMIT_ERROR:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        response };
    case types.DONOR_UPDATE_SUCCESS:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        response };  
    case types.DONOR_UPDATE_ERROR:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        response };
    case types.DONOR_SELFSERVICE_SUCCESS:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        response };  
    case types.DONOR_SELFSERVICE_ERROR:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        response };        
    case types.NOTIFY_DONORS_SUCCESS:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        response };  
    case types.NOTIFY_DONORS_ERROR:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        response };  
    case types.ALL_DONORS_FETCH_SUCCESS:
      allDonors = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        findByPhone: false,
        allDonors };
    case types.ALL_DONORS_FETCH_ERROR:
      allDonors = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        allDonors };
    case types.DONOR_FETCHBYPHONE_SUCCESS:
      allDonors = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        findByPhone: true,
        allDonors };
    case types.DONOR_FETCHBYPHONE_ERROR:
      allDonors = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        allDonors };
    case types.ADD_VOLUNTEER_DONOR_SUCCESS:
      addVolunteerDonor = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        addVolunteerDonor };
    case types.ADD_VOLUNTEER_DONOR_ERROR:
      addVolunteerDonor = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        addVolunteerDonor };
    case types.DELETE_VOLUNTEER_DONOR_SUCCESS:
      deleteVolunteerDonor = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        deleteVolunteerDonor };
    case types.DELETE_VOLUNTEER_DONOR_ERROR:
      deleteVolunteerDonor = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        deleteVolunteerDonor };
    case types.ADD_ACTUAL_DONOR_SUCCESS:
      addActualDonor = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        addActualDonor };
    case types.ADD_ACTUAL_DONOR_ERROR:
      addActualDonor = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        addActualDonor };        
    case types.IMPORT_DONORS_SUCCESS:
      importDonors = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        importDonors };
    case types.IMPORT_DONORS_ERROR:
      importDonors = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        importDonors };
    case types.SEND_OTP_DONOR_SUCCESS:
      sendOTPDonor = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        sendOTPDonor };
    case types.SEND_OTP_DONOR_ERROR:
      sendOTPDonor = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        sendOTPDonor };                                  
    default:
      return state;
  }
};